/**
 * @generated SignedSource<<98ec2aa53c96aaf852351d70669f6a53>>
 * @relayHash 5c639f7d0e79d6716c92eff01e98448f
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5c639f7d0e79d6716c92eff01e98448f

import { ConcreteRequest } from 'relay-runtime';
export type useCallContextStoreVerifyIgnorePhoneNumberQuery$variables = {
  phoneNumber: string;
};
export type useCallContextStoreVerifyIgnorePhoneNumberQuery$data = {
  readonly verifyIgnorePhoneNumber: boolean;
};
export type useCallContextStoreVerifyIgnorePhoneNumberQuery = {
  response: useCallContextStoreVerifyIgnorePhoneNumberQuery$data;
  variables: useCallContextStoreVerifyIgnorePhoneNumberQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "phoneNumber"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "phoneNumber",
        "variableName": "phoneNumber"
      }
    ],
    "kind": "ScalarField",
    "name": "verifyIgnorePhoneNumber",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCallContextStoreVerifyIgnorePhoneNumberQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCallContextStoreVerifyIgnorePhoneNumberQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "5c639f7d0e79d6716c92eff01e98448f",
    "metadata": {},
    "name": "useCallContextStoreVerifyIgnorePhoneNumberQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5d88a5e3cc657f4fa0acd8e451448184";

export default node;
